export default __webpack_public_path__ + "static/media/900.e70ad230.gif";